export default "__VITE_PUBLIC_ASSET__5fffa9a5__"